window.initHenceNativeMix = function initHenceNativeMix(root) {
 if(!root)return () => {};
 const controller=new AbortController();
 const clamp = value => Math.max(0,Math.min(1,value));
 const smooth=(a,b,value)=>{const t=clamp((value-a)/(b-a));return t*t*(3-2*t)};
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const story=root.querySelector('.mix-story'); if(!story) return;
 const section=story.closest('.mix-section'),stage=story.querySelector('.mix-stage');
 const canvas=story.querySelector('.mix-pour'),ctx=canvas.getContext('2d');
 const phases=[...story.querySelectorAll('[data-mix-phase]')];
 const fillOnly=true;
 const paired=fillOnly&&true;
 const powderTrial=true;
 let progress=0,frame=0,scrolling=false;
 const liquidTexture=new Image();let textureReady=false;
 liquidTexture.onload=()=>{textureReady=true;paint(progress);};
 liquidTexture.src=root.dataset.liquidSrc;
 const finishedLiquid=new Image();let finishedReady=false;
 finishedLiquid.onload=()=>{finishedReady=true;paint(progress);};
 finishedLiquid.src=root.dataset.filledSrc;
 const grains=Array.from({length:1150},(_,i)=>({x:Math.sin(i*127.1)*.5+.5,y:Math.sin(i*311.7)*.5+.5,phase:(i*.61803398875)%1}));
 // Fixed release velocities and gravity keep the stream narrow until impact.
 // Precomputed arrival times let the heap grow only when material reaches it.
 let powderSeed=2718;
 const powderRandom=()=>{powderSeed=(Math.imul(powderSeed,1664525)+1013904223)>>>0;return powderSeed/4294967296;};
 const powderSurface=(x,volume,remaining=1)=>{
  const scale=Math.cbrt(Math.max(0,volume)),radius=78*scale;
  const u=radius?Math.min(1,Math.abs(x-303)/radius):1;
  return 754-(7+54*remaining)*scale*Math.pow(1-u,.88);
 };
 const powder=Array.from({length:1450},()=>{
  const birth=powderRandom()*1.35,x=303+(powderRandom()-.5)*8,vx=(powderRandom()-.5)*9;
  const vy=32+powderRandom()*24,size=.4+powderRandom()*.8,shade=powderRandom(),spread=powderRandom();
  let flight=.9;
  for(let n=0;n<5;n++){
   const volume=clamp((birth+flight-.9)/1.35);
   const floor=powderSurface(x+vx*flight,volume);
   flight=(-vy+Math.sqrt(vy*vy+3000*(floor-91)))/1500;
  }
  return {birth,x,vx,vy,size,shade,spread,flight,arrival:birth+flight};
 });
 const heapGrains=Array.from({length:1250},()=>({x:powderRandom(),y:powderRandom(),shade:powderRandom()}));
 // Separate seed leaves the baseline release simulation byte-for-byte deterministic.
 // Fleck colours recall the master splash; they do not encode ingredient ratios.
 let bedSeed=9173;
 const bedRandom=()=>{bedSeed=(Math.imul(bedSeed,1664525)+1013904223)>>>0;return bedSeed/4294967296;};
 const bedGrains=powderTrial?Array.from({length:4600},()=>({x:bedRandom(),y:bedRandom(),shade:bedRandom(),size:bedRandom()})):[];
 const trialSurface=(x,volume,remaining)=>{
  const scale=Math.cbrt(volume),radius=78*scale,u=(x-303)/radius;
  const edge=Math.max(0,1-u*u);
  const ridge=Math.pow(edge,1.42)*(1+.10*u)+.035*Math.sin(u*13+1)*edge;
  return 754-(7+54*remaining)*scale*ridge;
 };


 function drawPour(p) {
  if(!ctx) return;
  ctx.clearRect(0,0,600,800);
  const powderTime=(p-.025)*7.5;
  const deposited=fillOnly?smooth(.025,.30,p):powder.reduce((count,g)=>count+(powderTime>=g.arrival?1:0),0)/powder.length;
  const water=smooth(.40,.76,p),mixed=smooth(.76,.96,p);
  const base=747,level=base-water*(base-330);
  const impact=fillOnly?0:smooth(.41,.51,p)*(1-smooth(.70,.77,p));
  const wave=Math.sin(p*109)*impact*2;
  const poolPath=()=>{
   ctx.beginPath();ctx.moveTo(212,level);
   ctx.bezierCurveTo(249,level-3+wave,272,level+3-wave,301,level-1);
   ctx.bezierCurveTo(329,level-3-wave,363,level+4+wave,389,level);
   ctx.lineTo(389,base-5);ctx.quadraticCurveTo(389,base+9,300,base+10);ctx.quadraticCurveTo(212,base+9,212,base-5);ctx.closePath();
  };
  ctx.save();ctx.beginPath();ctx.roundRect(211,243,180,base+10-243,17);ctx.clip();
  if(deposited>0) {
   const remaining=1-smooth(.46,.91,p)*.94;
   const radius=78*Math.cbrt(deposited);
   const surface=x=>powderTrial?trialSurface(x,deposited,remaining):powderSurface(x,deposited,remaining);
   const sediment=ctx.createLinearGradient(0,surface(303),0,base+10);
   if(powderTrial){sediment.addColorStop(0,'#9a9d65');sediment.addColorStop(.35,'#7e8750');sediment.addColorStop(1,'#4c6033');}
   else{sediment.addColorStop(0,'#8b9c44');sediment.addColorStop(.25,'#61752a');sediment.addColorStop(1,'#354d19');}
   ctx.save();ctx.beginPath();ctx.moveTo(303-radius,754);
   for(let n=0;n<=48;n++){const x=303-radius+n*radius/24;ctx.lineTo(x,surface(x));}
   ctx.quadraticCurveTo(303,761,303-radius,754);ctx.closePath();ctx.clip();
   ctx.fillStyle=sediment;ctx.fillRect(211,base-70,180,90);
   // The same surface defines the silhouette, grain texture and landing point.
   if(powderTrial){
    // Broad, low-opacity clumps sit under fine irregular grains for a matte bed.
    bedGrains.slice(0,180).forEach(g=>{
     const x=303+(g.x-.5)*radius*2,top=surface(x),y=top+g.y*(758-top);
     ctx.globalAlpha=.035+g.shade*.045;ctx.fillStyle=g.shade<.5?'#d2cf97':'#344b27';
     ctx.beginPath();ctx.ellipse(x,y,2+g.size*5,1+g.size*2.8,g.x*3,0,Math.PI*2);ctx.fill();
    });
    let orangeCrumbs=0;
    bedGrains.slice(0,Math.ceil(bedGrains.length*deposited)).forEach((g,i)=>{
     const x=303+(g.x-.5)*radius*2,top=surface(x),y=top+g.y*(758-top);
     // Sparse coarser crumbs survive downscaling into the mobile bottle.
     const candidate=i%23===0&&g.shade<.20;
     const crumb=i%23===0&&(!candidate||++orangeCrumbs%3!==0),orange=crumb&&candidate;
     const fleck=crumb?(g.shade<.20?'#e99325':g.shade<.48?'#d4c791':g.shade<.58?'#68846a':'#819253'):(g.shade<.045?'#bd802d':g.shade<.12?'#c8c08c':g.shade<.16?'#567f6a':g.shade<.56?'#a3ab72':g.shade<.85?'#718346':'#40562b');
     ctx.fillStyle=fleck;ctx.globalAlpha=orange?.94:crumb?.66+g.size*.22:.32+g.size*.38;
     ctx.beginPath();ctx.ellipse(x,y,orange?1.44+g.size*.96:crumb?.85+g.size*.85:.22+g.size*.64,orange?.72+g.size*.56:crumb?.55+g.size*.58:.18+g.size*.38,g.x*6.28,0,Math.PI*2);ctx.fill();
    });
   }else heapGrains.slice(0,Math.ceil(heapGrains.length*deposited)).forEach(g=>{
    const x=303+(g.x-.5)*radius*2,top=surface(x);
    const y=top+g.y*(758-top);
    ctx.fillStyle=g.shade<.3?'#b4be6a':g.shade<.7?'#6b7d30':'#3f591e';
    ctx.globalAlpha=.35+g.shade*.2;ctx.fillRect(x,y,.45+g.shade,.7+g.shade*.5);
   });ctx.restore();ctx.globalAlpha=1;
  }

  if(water>0) {
   ctx.save();poolPath();ctx.clip();
   const clear=ctx.createLinearGradient(212,0,389,0);
   clear.addColorStop(0,'rgba(75,118,94,.22)');clear.addColorStop(.18,'rgba(139,173,135,.10)');clear.addColorStop(.74,'rgba(85,121,80,.13)');clear.addColorStop(1,'rgba(27,67,36,.27)');
   ctx.fillStyle=clear;ctx.fillRect(211,level-8,180,base+20-level);

   // Water lifts pigment from the powder bed into branching, curling plumes.
   // The ascending bloom broadens into a dense suspension as it mixes.
   // Everything is a pure function of scroll, so reversing retraces the pour.
   const bloom=smooth(.42,.81,p),depth=base-level;
   for(let i=0;i<14;i++) {
    const g=grains[i],born=.405+g.phase*.15;
    const age=clamp((p-born)/(.32+g.x*.1));if(!age)continue;
    const reach=Math.min(depth-5,depth*(.10+age*1.85));
    for(let j=0;j<32;j++) {
     const t=clamp((j+Math.sin((i+1)*(j+3)*2.3)*.4)/31);
     const direction=i%2?1:-1;
     const branch=direction*(12+g.x*52)*Math.sin(t*1.8)*Math.min(1,age*2);
     const curl=Math.sin(t*10.5+g.phase*6+p*4)*Math.sin(t*3.1)*(9+age*14);
     const x=288+g.y*24+branch+curl;
     const y=base-t*reach+Math.sin(t*8+g.phase*8)*Math.sin(t*3.14)*18*age;
     const r=(3+g.y*5+age*12+mixed*30)*(1-t*.12)*(1+Math.sin(t*13+g.phase*9)*.18+Math.cos(t*31+g.y*12)*.12);
     const cloud=ctx.createRadialGradient(x,y,r*.04,x,y,r);
     const alpha=(.13+age*.32)*(1-t*.25);
     cloud.addColorStop(0,`rgba(${i%4===0?'62,83,17':'10,48,23'},${alpha})`);
     cloud.addColorStop(.50,`rgba(25,65,26,${alpha*.78})`);cloud.addColorStop(1,'rgba(37,76,27,0)');
     ctx.fillStyle=cloud;ctx.fillRect(x-r,y-r,r*2,r*2);
    }
   }
   // Finer pigment fingers peel away from the larger ascending bloom.
   for(let i=0;i<9;i++) {
    const g=grains[50+i],age=clamp((p-(.43+g.phase*.12))/.28);
    if(!age)continue;
    const reach=depth*Math.min(.94,age*1.6),side=i%2?1:-1;
    const x=298+(g.x-.5)*28;
    ctx.beginPath();ctx.moveTo(x,base-12);
    ctx.bezierCurveTo(x-side*22,base-reach*.3,x+side*76,base-reach*.68,x+side*38,base-reach);
    ctx.lineWidth=1+g.y*3;ctx.strokeStyle=`rgba(22,64,25,${.28*age*(1-mixed*.7)})`;ctx.stroke();
   }
   const density=ctx.createLinearGradient(0,level,0,base);
   density.addColorStop(0,`rgba(10,38,18,${mixed*.72})`);
   density.addColorStop(.32,`rgba(21,53,21,${mixed*.54})`);
   density.addColorStop(1,`rgba(14,34,15,${bloom*.28+mixed*.42})`);
   ctx.fillStyle=density;ctx.fillRect(211,level-5,180,base+25-level);
   // Reuse the selected bottle-panel liquid as a restrained final material layer.
   if(textureReady) {
    ctx.save();ctx.globalAlpha=smooth(.68,.94,p)*.64;
    ctx.translate(211,base);ctx.rotate(-Math.PI/2);
    ctx.drawImage(liquidTexture,380,0,820,400,0,0,depth,180);ctx.restore();
   }
   // Fine particles follow a circulating flow, with sediment remaining below.
   grains.forEach((g,i)=>{
    const rise=(g.phase+p*.8)%1;
    const x=301+Math.sin(rise*8+i*.47+p*2)*76*g.x;
    const y=base-rise*Math.max(0,depth-3);
    ctx.globalAlpha=(.12+g.y*.32)*bloom;
    ctx.fillStyle=i%5?'#244519':'#a3ad60';
    ctx.beginPath();ctx.arc(x,y,.25+g.x*.65,0,Math.PI*2);ctx.fill();
   });
   ctx.globalAlpha=1;
   // A registered photographic material resolves inside the liquid only.
   // The glass silhouette, neck, base and brand mark never crossfade or move.
   if(finishedReady) {
    ctx.save();ctx.globalAlpha=smooth(.60,.94,p);
    ctx.drawImage(finishedLiquid,350,354,390,920,211,level,180,base+10-level);
    ctx.restore();
   }
   // Six tiny orange specks remain visible above the photographic liquid.
   // Seeded positions circulate gently with scroll inside the existing pool clip.
   if(powderTrial) {
    for(let i=0;i<6;i++) {
     const g=grains[180+i*149],rise=(i/6+g.phase*.06+p*.18)%1;
     const x=300+(g.x-.5)*120+Math.sin(rise*6.28+g.phase*6.28+p*.7)*8;
     const y=base-10-rise*Math.max(0,depth-22);
     ctx.globalAlpha=(.45+g.y*.17)*bloom;ctx.fillStyle='#bd802d';
     ctx.beginPath();ctx.arc(x,y,.55+g.x*.35,0,Math.PI*2);ctx.fill();
    }
    ctx.globalAlpha=1;
   }
   ctx.restore();
   // Meniscus, uneven foam and a restrained impact ripple sit on the surface.
   ctx.save();ctx.globalAlpha=finishedReady?1-smooth(.60,.94,p):1;
   ctx.strokeStyle='rgba(53,81,32,.55)';ctx.lineWidth=2;
   ctx.beginPath();ctx.ellipse(300,level+1,87,4.3,0,0,Math.PI*2);ctx.stroke();
   for(let i=0;i<130;i++) {
    const g=grains[i];const x=215+g.x*171,y=level+Math.sin(g.x*6.2)*2+g.y*(3+bloom*7);
    ctx.fillStyle=i%3?'rgba(118,139,78,.36)':'rgba(204,214,169,.56)';
    ctx.beginPath();ctx.arc(x,y,.4+g.phase*1.7,0,Math.PI*2);ctx.fill();
   }
   for(let i=0;i<3;i++) {
    const spread=((p*13+i*.32)%1),radius=7+spread*26;
    ctx.strokeStyle=`rgba(237,245,217,${(1-spread)*impact*.35})`;ctx.lineWidth=.8;
    ctx.beginPath();ctx.ellipse(303,level+1,radius,1.4+spread*2.5,0,0,Math.PI*2);ctx.stroke();
   }
   ctx.restore();
  }
  ctx.restore();
  // Grains accelerate from the scoop, then make a tiny outward bounce and settle.
  if(!fillOnly && p>.025 && p<.36) powder.forEach(g=>{
   const age=powderTime-g.birth;if(age<0)return;
   let x=g.x+g.vx*Math.min(age,g.flight),y;
   if(age<g.flight)y=91+g.vy*age+750*age*age;
   else {
    const landed=age-g.flight;if(landed>.14)return;
    const direction=x<303?-1:1;
    x+=direction*landed*(34+g.spread*48);
    y=powderSurface(x,deposited)-Math.sin(Math.PI*landed/.14)*(1+g.spread*3);
   }
   ctx.globalAlpha=.58+g.shade*.38;ctx.fillStyle=g.shade<.7?'#607723':'#8fa348';
   ctx.beginPath();ctx.ellipse(x,y,g.size,g.size*(age<g.flight?1.5:1),0,0,Math.PI*2);ctx.fill();
  });ctx.globalAlpha=1;
  const stream=smooth(.385,.425,p)*(1-smooth(.70,.755,p));
  if(!fillOnly && stream>0) {
   // The free jet terminates at the surface; its submerged flow is pigment.
   const end=Math.min(base-20,level+3);
   ctx.globalAlpha=stream;
   for(const [stroke,width,offset] of [['#396d5f80',7.4,0],['#e6f3e6e6',3.5,1.4],['#a6c0b294',1.1,-2.4]]) {
    ctx.strokeStyle=stroke;ctx.lineWidth=width;ctx.lineCap='round';ctx.beginPath();ctx.moveTo(309+offset,100);
    for(let n=1;n<=26;n++){
     const t=n/26,y=100+(end-100)*t;
     ctx.lineTo(309+offset-6*Math.min(t*5,1)+Math.sin(y*.06+p*90)*.8*t,y);
    }ctx.stroke();
   }
   ctx.globalAlpha=1;
  }
 }

 function paint(p) {
  progress=clamp(p);
  stage.style.setProperty("--mix-progress",`${(progress*100).toFixed(2)}%`);
  if(paired)p=clamp((p-.06)/.72);
  stage.style.setProperty("--cue-opacity",String(1-smooth(.01,.09,p)));
  stage.style.setProperty('--scoop-opacity',(1-smooth(.28,.35,p)).toFixed(3));
  stage.style.setProperty('--jug-opacity',(smooth(.34,.39,p)*(1-smooth(.70,.77,p))).toFixed(3));
  stage.style.setProperty('--lid-opacity',smooth(.785,.815,p).toFixed(3));
  const capTurn=smooth(.865,.95,p);
  stage.style.setProperty('--lid-rise',`${(-22*(1-smooth(.81,.865,p))-4*(1-capTurn)).toFixed(2)}%`);
  stage.style.setProperty('--lid-grain-shift',`${(-100*(1-capTurn)).toFixed(2)}px`);
  const active=p<.34?0:p<.77?1:2;
  phases.forEach((phase,i)=>{
   const opacity=i===active?1:0;
   phase.style.setProperty('--phase-opacity',opacity.toFixed(3));
   phase.style.setProperty('--copy-offset',`${(1-opacity)*10}px`);
   phase.classList.toggle('is-active',i===active);phase.setAttribute('aria-hidden',String(i!==active));
  });
  drawPour(p);
 }
 function render() {
  frame=0;if(document.hidden||!scrolling)return;
  const rect=story.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;
  const top=parseFloat(getComputedStyle(stage).top)||0;
  paint((top-rect.top)/Math.max(1,story.offsetHeight-stage.offsetHeight));
 }
 function schedule(){if(!frame&&scrolling)frame=requestAnimationFrame(render);}
 function resize(){
  scrolling=!reduced.matches&&innerHeight>=660;
  section.classList.toggle('mix-scroll',scrolling);
  const ratio=Math.min(devicePixelRatio||1,2);
  canvas.width=600*ratio;canvas.height=800*ratio;
  if(ctx)ctx.setTransform(ratio,0,0,ratio,0,0);
  if(!scrolling&&frame){cancelAnimationFrame(frame);frame=0;}
  paint(scrolling?progress:.96);schedule();
 }
 const observer='IntersectionObserver' in window?new IntersectionObserver(([entry])=>root.classList.toggle('viewing-preparation',entry.isIntersecting),{threshold:.25}):null;
 observer?.observe(stage);
 section.classList.add('mix-enhanced');
 addEventListener('scroll',schedule,{passive:true,signal:controller.signal});addEventListener('resize',resize,{passive:true,signal:controller.signal});
 addEventListener('pageshow',resize,{signal:controller.signal});reduced.addEventListener('change',resize,{signal:controller.signal});
 document.addEventListener('visibilitychange',schedule,{signal:controller.signal});
 resize();
 return () => {controller.abort();observer?.disconnect();if(frame)cancelAnimationFrame(frame);liquidTexture.onload=null;finishedLiquid.onload=null;};
};

